import React, { useState } from "react";
import { Link } from "react-router-dom";
import ParcelIcon from "../../../helper/svg/income.svg";
import ResrvationIcon from "../../../helper/svg/reservationicon.svg";
import Incomeicon from "../../../helper/svg/incomeicon.svg";
import Moneybage from "../../../helper/svg/money-bag.svg";
import { LuUsersRound } from "react-icons/lu";
import { PiCurrencyCircleDollar } from "react-icons/pi";
import { MdOutlineFastfood } from "react-icons/md";
import HotelIcon from "../../../helper/svg/yellowhotel.svg";
import ServiceID from "../../../helper/svg/serviceId.svg";
import CommissionPanel from "./CommisionPannel";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getDashboardInsights,
  getRestaurantOrders,
  getUserReports,
} from "../../../api/admin/dashboard";
import { getAllNotifications } from "../../../api/common/notifications";
import Pagination from "../../../components/common/Pagination";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";
import { useTranslation } from "../../../hooks/useTranslation";
const PopupModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
      <div className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[978px] relative sm:shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-[33px] right-[30px] text-[#9E9E9E] hover:text-black"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const AdminDashboard = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const limit = 10;
  const [selectedOrder, setSelectedOrder] = useState({});

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["dashboardInsights"],
    queryFn: getDashboardInsights,
    keepPreviousData: true,
  });

  const {
    data: ordersData,
    isLoading: loading,
    isError: orderError,
    error: orderErrorDetails,
  } = useQuery({
    queryKey: ["restaurantOrders", page],
    queryFn: () => getRestaurantOrders({ page, limit }),
    keepPreviousData: true,
  });

  const {
    data: notificationsData,
    isLoading: loadingNotifications,
    isError: errorNotifications,
  } = useQuery({
    queryKey: ["notifications"],
    queryFn: getAllNotifications,
    keepPreviousData: true,
  });

  const { data: usersData } = useQuery({
    queryKey: ["users"],
    queryFn: getUserReports,
    keepPreviousData: true,
  });

  const insights = data?.data;
  const orders = ordersData?.data?.orders;
  const pagination = ordersData?.data?.pagination || {};
  const notifications = notificationsData?.data?.notifications || [];
  const chartData = usersData?.data?.report || [];

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const chartDataModified = (chartData) => {
    return chartData.map((entry) => ({
      name: months[entry.month - 1],
      thisYear: entry.currentYear.user + entry.currentYear.owner,
      lastYear: entry.previousYear.user + entry.previousYear.owner,
    }));
  };

  const transformedData = chartDataModified(chartData);

  const openModel = (order) => {
    setSelectedOrder(order);
    setIsPopupOpen(true);
  };

  return (
    <>
      {/* =================Card Section================ */}
      <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-col-1 sm:gap-[16px] gap-[10px] ">
        {/* 1st card */}
        <div className="flex justify-between 2xl:p-[25px] lg:p-[20px] p-[15px] border border-[#E4E4E4] rounded-[10px] bg-[#fff] items-center">
          <div className="flex 2xl:gap-[18px] gap-[10px] items-center">
            <img
              src={ParcelIcon}
              alt="logo"
              className="2xl:w-[37px] w-[20px]"
            />
            <p className="2xl:text-xl text-base font-semibold lg:leading-[30px] leading-[25px]">
              {t("admindashboard").totalRevenue}
            </p>
          </div>
          <div>
            <p className="2xl:text-xl text-base font-semibold text-[#4CAF50]">
              ₾{insights?.totalRevenue}
            </p>
          </div>
        </div>
        {/* 2nd card */}
        <div className="flex justify-between 2xl:p-[25px] lg:p-[20px] p-[15px] border border-[#E4E4E4] rounded-[10px] bg-[#fff] items-center">
          <div className="flex 2xl:gap-[18px] gap-[10px] items-center">
            <PiCurrencyCircleDollar className="text-[#FFA808] 2xl:text-[30px] text-[20px]" />
            <p className="2xl:text-xl text-base font-semibold lg:leading-[30px] leading-[25px]">
              {t("admindashboard").dailyRevenue}
            </p>
          </div>
          <div>
            <p className="2xl:text-xl text-base font-semibold text-[#4CAF50]">
              ₾{insights?.dailyRevenue}
            </p>
          </div>
        </div>
        {/* 3rd card */}
        <div className="flex justify-between 2xl:p-[25px] lg:p-[20px] p-[15px] border border-[#E4E4E4] rounded-[10px] bg-[#fff] items-center">
          <div className="flex 2xl:gap-[18px] gap-[10px] items-center">
            <img src={Moneybage} alt="logo" className="2xl:w-[37px] w-[20px]" />
            <p className="2xl:text-xl text-base font-semibold lg:leading-[30px] leading-[25px]">
              {t("admindashboard").weeklyRevenue}
            </p>
          </div>
          <div>
            <p className="2xl:text-xl text-base font-semibold text-[#4CAF50]">
              ₾{insights?.weeklyRevenue}
            </p>
          </div>
        </div>
        {/* 4th card */}
        <div className="flex justify-between 2xl:p-[25px] lg:p-[20px] p-[15px] border border-[#E4E4E4] rounded-[10px] bg-[#fff] items-center">
          <div className="flex 2xl:gap-[18px] gap-[10px] items-center">
            <MdOutlineFastfood className="text-[#FFA808] 2xl:text-[30px] text-[20px]" />

            <p className="2xl:text-xl text-base font-semibold lg:leading-[30px] leading-[25px]">
              {t("admindashboard").restaurants}
            </p>
          </div>
          <div>
            <p className="2xl:text-xl text-base font-semibold text-[#4CAF50]">
              {insights?.restaurants} {t("admindashboard").restaurants}
            </p>
          </div>
        </div>
        {/* 5th card */}
        <div className="flex justify-between 2xl:p-[25px] lg:p-[20px] p-[15px] border border-[#E4E4E4] rounded-[10px] bg-[#fff] items-center">
          <div className="flex 2xl:gap-[18px] gap-[10px] items-center">
            <img src={HotelIcon} alt="logo" className="2xl:w-[37px] w-[20px]" />

            <p className="2xl:text-xl text-base font-semibold lg:leading-[30px] leading-[25px]">
              {t("admindashboard").hotels}
            </p>
          </div>
          <div>
            <p className="2xl:text-xl text-base font-semibold text-[#4CAF50]">
              {insights?.hotels} {t("admindashboard").hotels}
            </p>
          </div>
        </div>
        {/* 6th card */}
        <div className="flex justify-between 2xl:p-[25px] lg:p-[20px] p-[15px] border border-[#E4E4E4] rounded-[10px] bg-[#fff] items-center">
          <div className="flex 2xl:gap-[18px] gap-[10px] items-center">
            <img src={ServiceID} alt="logo" className="2xl:w-[37px] w-[20px]" />

            <p className="2xl:text-xl text-base font-semibold lg:leading-[30px] leading-[25px]">
              {t("admindashboard").services}
            </p>
          </div>
          <div>
            <p className="2xl:text-xl text-base font-semibold text-[#4CAF50]">
              {insights?.transactions} {t("admindashboard").transactions}
            </p>
          </div>
        </div>
      </div>

      {/* =================Graph Section================ */}
      <div className="grid 2xl:grid-cols-[1fr_594px_1fr] xl:grid-cols-3 md:grid-cols-2 grid-col-1 sm:gap-[21px] gap-[10px] mt-[24px]">
        {/* 1st graph */}
        <div className="2xl:p-[24px] p-[15px] border-[#E0E0E0] rounded-[16px] bg-[#fff] min-h-[318px] border w-full">
          <h2 className="2xl:text-lg text-base font-medium text-black mb-[16px]">
            {t("admindashboard").totalUsers}
          </h2>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart
              data={transformedData}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis tickFormatter={(value) => `${value}`} />
              <Tooltip formatter={(value) => `${value}`} />
              <Legend />
              <Line
                type="monotone"
                dataKey="thisYear"
                stroke="#FFA500"
                strokeWidth={1.5}
                name="This Year"
              />
              <Line
                type="monotone"
                dataKey="lastYear"
                stroke="#28a745"
                strokeDasharray="5 5"
                strokeWidth={1.5}
                name="Last Year"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="2xl:p-[24px] p-[15px] border-[#E0E0E0] rounded-[16px] bg-[#fff] min-h-[318px] border w-full ">
          <CommissionPanel />
        </div>

        {/* Notifications */}
        <div className="2xl:p-[24px] p-[15px] border-[#E0E0E0] rounded-[16px] bg-[#fff] min-h-[318px] border w-full">
          <h2 className="2xl:text-lg text-base font-medium text-black mb-[16px]">
            {t("admindashboard").notifications}
          </h2>

          <ul className="flex flex-col gap-[3px] max-h-[250px] overflow-y-auto">
            {notifications.length > 0 ? (
              notifications.map((item, index) => (
                <li
                  key={item._id || index}
                  className="flex flex-col text-base text-[#18181B] py-[8px]"
                >
                  {item.message}
                  <span className="text-xs opacity-[40%]">
                    {new Date(item.createdAt).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </li>
              ))
            ) : (
              <li className="text-[16px] text-[#999] py-[8px] text-center">
                {t("admindashboard").noNotifications}
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* =================Recent order Section================ */}
      <div className="mt-[31px]">
        <h2 className="text-[22px] font-medium">
          {t("admindashboard").recentOrders}
        </h2>
        <div className="rounded-[10px] border border-[#D9D9D9] overflow-hidden mt-[28px]">
          <div className="overflow-x-auto ">
            <table className="min-w-full bg-white ">
              <thead className="bg-[#FFFAF2] ">
                <tr className="">
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("admindashboard").orderId}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("admindashboard").customerName}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("admindashboard").status}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("admindashboard").totalAmount}
                  </th>

                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("admindashboard").action}
                  </th>
                </tr>
              </thead>
              <tbody>
                {orders && orders.length > 0 ? (
                  orders.map((order, index) => (
                    <tr
                      key={order._id || index}
                      className="border-t border-[#E4E4E4]"
                    >
                      <td className="py-[16px] px-[32px] text-[18px] font-normal text-black">
                        {/* #{order._id?.slice(-6).toUpperCase() || `ORD-${index + 1}`} */}
                        {order?.orderId}
                      </td>
                      <td className="py-[16px] px-[32px] text-[18px] font-normal text-black whitespace-nowrap">
                        {order.userId?.name || "N/A"}
                      </td>
                      <td className="py-[16px] px-[32px] text-[18px] font-normal text-black whitespace-nowrap">
                        {order.paymentStatus || "Pending"}
                      </td>
                      <td className="py-[16px] px-[32px] text-[18px] font-normal whitespace-nowrap">
                        ₾{order.totalAmount?.toFixed(2) || "0.00"}
                      </td>

                      <td className="py-[27px] px-[32px]">
                        <button
                          onClick={() => openModel(order)}
                          className="text-[#4CAF50] underline font-normal"
                        >
                          {t("admindashboard").view}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-gray-500">
                      {t("admindashboard").noOrders}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {orders?.length > 0 && (
            <Pagination
              page={pagination.page}
              totalPages={pagination.totalPages}
              setPage={setPage}
            />
          )}
        </div>
      </div>

      <PopupModal isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
        <div className="w-full rounded-[20px] md:p-[30px] py-[20px] px-[15px]">
          <div className="grid grid-col-1 sm:grid-cols-3 justify-between text-left pb-[21px] border-b border-[#EEEEEE] mb-[18px]">
            <h2 className="text-[22px] font-medium col-span-2">
              {t("admindashboard").orderDetail}
            </h2>
          </div>
          <div className="h-[350px] overflow-y-auto">
            <p className="text-[17px] font-medium mb-[15px]">
              {t("admindashboard").for}: {selectedOrder?.orderId} -{" "}
              {selectedOrder?.userId?.name}'s Order
            </p>
            <div className="border border-[#DDDDDD] rounded-[5px] xl:gap-[47px] gap-[20px] p-[20px] pb-[36px] bg-white grid lg:grid-cols-[auto_auto_1fr] md:grid-cols-2 grid-cols-1">
              <div>
                <h2 className="text-[17px] font-medium text-black">
                  {t("admindashboard").orderInfo}
                </h2>
                <ul className="mt-5">
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").orderId}:
                    </span>
                    {selectedOrder?.orderId}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").customerName}:
                    </span>
                    {selectedOrder?.userId?.name}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").tableNumber}:
                    </span>
                    {selectedOrder?.reservationId?.tableNo || selectedOrder?.tableNumber || "-"}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").restaurant}:{" "}
                    </span>
                    {selectedOrder?.reservationId?.restaurantId?.name || selectedOrder?.restaurantId?.name || "-"}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").orderType}:{" "}
                    </span>
                    {selectedOrder?.reservationId ? "Reservation Order" : "Direct Order"}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").slotTime}:{" "}
                    </span>{" "}
                    1:9am
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").orderDate}:{" "}
                    </span>
                    {moment(selectedOrder?.reservationId?.bookingDate).format(
                      "MM/DD/YYYY"
                    )}
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="text-[17px] font-medium text-black">
                  {t("admindashboard").paymentInfo}
                </h2>
                <ul className="mt-5">
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").paymentMethod}:
                    </span>
                    {selectedOrder?.paymentMethod}
                  </li>
                  <li className="text-[17px]  mb-[10px] text-[#FF9D00]">
                    <span className="font-medium text-[#757474]">
                      {t("admindashboard").paymentStatus}:
                    </span>{" "}
                    {selectedOrder?.paymentStatus}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">
                      {t("admindashboard").subTotal}:
                    </span>{" "}
                    ₾{selectedOrder?.subtotal}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium text-orange-500">
                      {t("admindashboard").discount}:
                    </span>{" "}
                    ₾{selectedOrder?.discountAmount}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium text-orange-500">
                      {t("admindashboard").tokenCharges}
                    </span>{" "}
                    ₾{selectedOrder?.tokenCharges}
                  </li>
                  {/* <li className="text-[17px] text-[#757474] mb-[10px]">
                          <span className="font-medium">Platform Fee :</span> ₾{selectedOrder?.platformFee}
                        </li> */}

                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Total:</span> ₾{selectedOrder?.totalAmount}
                  </li>

                  <li className="text-[17px] text-[#757474] mb-[10px] text-green-700">
                    <span className="font-medium">
                      {t("admindashboard").platformFee} :
                    </span>{" "}
                    ₾{selectedOrder?.platformFee}
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="text-[17px] font-medium text-black">
                  {t("admindashboard").orderStatus}
                </h2>
                <ul className="mt-5">
                  <li className="text-[17px]  mb-[10px] text-[#FF9D00]">
                    <span className="font-medium text-[#757474]">
                      {t("admindashboard").currentStatus}:
                    </span>{" "}
                    {selectedOrder?.orderStatus}
                  </li>
                  {/* <li className="text-[17px] text-[#757474] mb-[10px]">
                          <span className="font-medium">Action Required:</span>{" "}
                          Payment confirmation
                        </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </PopupModal>
    </>
  );
};

export default AdminDashboard;
